import { orgOrganisationKeys } from 'components/Search/Filters/keys';
import { getStringValue } from './getStringValue';
import { isExcluded } from './isExcluded';

const andJoin = strArray => strArray.join(' AND ');
const orJoin = strArray => strArray.join(' OR ');
const not = str => `NOT (${str})`;
const wrapQuotes = str => `"${str}"`;
const wrapWildcardQuotes = str => wrapQuotes(`*${str}*`);
const keyValuePair = (key, value) => `${key}:(${value})`;

export const organisationNameBuilder = (key, valuesArr, filters) => {
  if (!Array.isArray(valuesArr)) return '';
  if (valuesArr.length <= 0) return '';
  const requiresExactNameMatch =
    filters[orgOrganisationKeys.organisationNameExactMatch.key] === true;

  const opensearchKey = requiresExactNameMatch ? `${key}.keyword` : key;
  const wrapTerm = requiresExactNameMatch ? wrapQuotes : wrapWildcardQuotes;

  const processedValues = valuesArr.reduce(
    (acc, value) => {
      if (typeof value !== 'string') {
        throw new TypeError(
          `Organisation Name Builder received an invalid value: ${value}`
        );
      }
      const isNegated = isExcluded(value);
      const cleaned = getStringValue(value);
      const wrapped = wrapTerm(cleaned);
      acc[isNegated ? 'excludes' : 'includes'].push(wrapped);
      return acc;
    },
    { includes: [], excludes: [] }
  );

  const clauses = [];

  if (processedValues.includes.length > 0) {
    const joinedIncludeValues = orJoin(processedValues.includes);
    clauses.push(keyValuePair(opensearchKey, joinedIncludeValues));
  }

  if (processedValues.excludes.length > 0) {
    const joinedExcludeValues = orJoin(processedValues.excludes);
    clauses.push(not(keyValuePair(opensearchKey, joinedExcludeValues)));
  }
  return andJoin(clauses);
};
